/* esm.sh - applesauce-common@5.2.0/dist/operations/app-data */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/app-data.mjs";
